import { useEffect, useRef, useState } from "react";

/**
 * Fica `true` na primeira vez que o elemento entra na tela e não volta mais.
 * Sem IntersectionObserver (ex.: Jest) considera o elemento visível.
 */
export const useInView = ({ threshold = 0.14, rootMargin = "0px 0px -40px 0px" } = {}) => {
  const ref = useRef(null);
  const [inView, setInView] = useState(false);

  useEffect(() => {
    const element = ref.current;
    if (!element || inView) return;

    if (typeof IntersectionObserver === "undefined") {
      setInView(true);
      return;
    }

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setInView(true);
          observer.disconnect();
        }
      },
      { threshold, rootMargin }
    );
    observer.observe(element);

    return () => observer.disconnect();
  }, [inView, threshold, rootMargin]);

  return [ref, inView];
};
